import React from 'react'

import { useInView } from 'react-cool-inview'

import { string, bool } from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'

import PrepositionBestPrices from './PrepositionBestPrices'
import PrepositionQualityStandard from './PrepositionQualityStandard'
import ThreeDModelPreposition from './ThreeDModelPreposition'
import ValuePropositionCard from './ValuePropositionCard'

function ValueProposition({ locale = 'en', extractingCoreStyles = false }) {
  const { observe, inView } = useInView({
    rootMargin: '200px',
    unobserveOnEnter: true,
  })

  const translate = (key, options = {}) => {
    const result = i18n.t(key, {
      ns: 'new-home',
      lng: locale,
      ...options,
    })
    return result
  }

  const renderValuePropositionContent = () => (
    <>
      <h2 className="value-proposition__title">
        {translate('valueProposition.title')}
      </h2>

      <div className="value-proposition__cards-container">
        <ValuePropositionCard
          icon={<ThreeDModelPreposition width="80" height="80" />}
          title={translate('valueProposition.cards.3dModels.title')}
          description={translate('valueProposition.cards.3dModels.description')}
        />

        <ValuePropositionCard
          icon={<PrepositionBestPrices width="80" height="80" />}
          title={translate('valueProposition.cards.bestPrices.title')}
          description={translate(
            'valueProposition.cards.bestPrices.description'
          )}
        />

        <ValuePropositionCard
          icon={<PrepositionQualityStandard width="80" height="80" />}
          title={translate('valueProposition.cards.qualityStandard.title')}
          description={translate(
            'valueProposition.cards.qualityStandard.description'
          )}
        />
      </div>
    </>
  )

  return (
    <div className="value-proposition new-home-section" ref={observe}>
      {(inView || extractingCoreStyles) && renderValuePropositionContent()}
      <noscript>
        {renderValuePropositionContent()}
      </noscript>
    </div>
  )
}

ValueProposition.propTypes = {
  locale: string,
  extractingCoreStyles: bool,
}

export default ValueProposition
